import * as React from "react"

import { GlobalState } from "../../../../../../store"
import { collectionSelector } from "../../../../../resources/adapters"
import { collectionUrl } from "../../../../../../util/UrlGenerator"
import { fetchCollection } from "../../../../../resources/thunks"
import { useAppDispatch, useAppSelector } from "../../../../../../hooks"

import Link from "../Link"
import UnavailableLink from "../UnavailableLink"

interface Props {
    attributes: Record<string, string>
    customLabel: string
    label: string
    collectionId: number
}

export const Collection = ({
    attributes,
    customLabel,
    label,
    collectionId,
}: Props): JSX.Element => {
    const dispatch = useAppDispatch()
    const resources = useAppSelector((state: GlobalState) => state.resources)
    const collection = collectionSelector.selectById(resources, collectionId)

    React.useEffect(() => {
        if (!collection) {
            dispatch(fetchCollection(collectionId))
        }
    }, [])

    if (!collection) {
        return (
            <UnavailableLink
                attributes={attributes}
                label={label}
                isLoading={true}
            />
        )
    } else if (collection.doesExist && !!collection.workspace?.doesExist) {
        const href = collectionUrl(collection)

        // we only show the title if there is no custom label
        const linkLabel =
            customLabel.length > 0 ? customLabel : collection.title

        return <Link attributes={attributes} label={linkLabel} href={href} />
    }

    return <UnavailableLink attributes={attributes} label={label} />
}

export default Collection
